export default __webpack_public_path__ + "static/Aeroport-regular-50de8fc876391815fe8777571354ca25.ttf";